module.exports = __webpack_public_path__ + "img/s1.0cc95b7e.png";